import { ROUTE_CHECKOUT } from '../constants';
import { PULSE_VIEW_ID } from './pulseViewIds';
import {
  PULSE_CLICK_ACTION,
  PULSE_CLICK_CATEGORY,
  trackPulseClick,
} from './pulseClickIds';

export type OrderTypeModalSource = 'header' | 'cart' | 'checkout';

export const resolveOrderTypeModalSource = ({
  modalSource,
  isCartOpen,
  pathname = '',
}: {
  modalSource?: OrderTypeModalSource;
  isCartOpen: boolean;
  pathname?: string;
}): OrderTypeModalSource => {
  if (modalSource) return modalSource;
  if (isCartOpen) return 'cart';
  if (pathname.replace(/\/+$/, '').includes(ROUTE_CHECKOUT)) return 'checkout';
  return 'header';
};

const categoryForOrderTypeModalSource = (
  source: OrderTypeModalSource
): string => {
  switch (source) {
    case 'header':
      return PULSE_CLICK_CATEGORY.HEADER;
    case 'cart':
      return PULSE_CLICK_CATEGORY.CART_PAGE;
    case 'checkout':
      return PULSE_CLICK_CATEGORY.CHECKOUT_PAGE;
    default:
      return PULSE_CLICK_CATEGORY.HEADER;
  }
};

/** Location selector modal — confirm pick-up or delivery order type. */
export const trackSelectOrderTypeClick = ({
  label,
  page_path,
  modalSource,
  isCartOpen = false,
}: {
  label: string;
  page_path?: string;
  modalSource?: OrderTypeModalSource;
  isCartOpen?: boolean;
}): void => {
  const path =
    page_path !== undefined
      ? page_path
      : typeof window !== 'undefined'
        ? window.location.pathname
        : undefined;

  const source = resolveOrderTypeModalSource({
    modalSource,
    isCartOpen,
    pathname: path ?? '',
  });
  const category = categoryForOrderTypeModalSource(source);

  trackPulseClick({
    category,
    action: PULSE_CLICK_ACTION.SELECT_ORDER_TYPE,
    label,
    view_id: PULSE_VIEW_ID.LOCATION_SELECTOR_MODAL,
    page_id: category,
    page_path: path,
  });
};
